import styled from "styled-components";
import { primaryColor } from "../../../pages/dash/styles";

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 30px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin: 20px 0;
  width: 100%;
  max-width: 100%;
`;


export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef2;
  padding-bottom: 10px;
`;

export const MediaUpload = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 20px;
  align-items: center;
`;

export const UploadBox = styled.div`
  height: 300px;
  width: 100%;
  max-width: 100%;

  border: 2px dashed #ebeef2;
  border-radius: 8px;
  padding: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  button {
    background-color: ${primaryColor};
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    margin-top: 10px;
    cursor: pointer;
    height: 40px;
    width: 151px;
  }
  small {
    font-size: 12px;
    color: #888888;
    margin-top: 10px;
  }
`;

export const UploadIcon = styled.div`
  color: ${primaryColor};
  margin-bottom: 5px;
`;

export const UploadText = styled.p`
  font-size: 18px;
  color: black;
  font-weight: 700;
  line-height: 1.4;
  span {
    font-weight: 400;
    font-size: 16px;
    color: #888888;
  }
`;

export const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export const Preview = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    margin-right: 270px;
    margin-bottom: 7px;
    align-items: center;
    font-size: 18px;
    color: #374151;
    font-weight: 300;
  }
`;

export const PreviewDiv = styled.div`
  background-color: #e5e7eb;
  height: 170px;
  width: 400px;
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;
`;


export const PreviewPlaceholder = styled.div`
  color: #888888;
  font-size: 14px;
  margin-top: 20px;
`;
